import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={21}
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8164 4.37836L13.5374 0.175773C13.4227 0.0631187 13.2683 0 13.1074 0H2.28953C1.02716 0 0 1.027 0 2.28953V18.655C0 19.9174 1.027 20.9445 2.28953 20.9445H15.7105C16.9728 20.9445 18 19.9175 18 18.655V4.81619C18 4.65144 17.9338 4.49373 17.8164 4.37836ZM13.721 2.07636L15.8859 4.20258H13.9161C13.8086 4.20258 13.721 4.11502 13.721 4.00747V2.07636ZM15.7105 19.7173H2.28953C1.70388 19.7173 1.22722 19.2408 1.22722 18.655V2.28953C1.22722 1.70372 1.70372 1.22722 2.28953 1.22722H12.494V4.00747C12.494 4.79174 13.132 5.4298 13.9163 5.4298H16.7728V18.655C16.7728 19.2408 16.2963 19.7173 15.7105 19.7173Z"
      fill="#4682B4"
    />
    <path
      d="M13.2597 9.73438H4.6097C4.27078 9.73438 3.99609 10.0091 3.99609 10.348C3.99609 10.6869 4.27078 10.9616 4.6097 10.9616H13.2597C13.5986 10.9616 13.8733 10.6869 13.8733 10.348C13.8733 10.0091 13.5986 9.73438 13.2597 9.73438Z"
      fill="#4682B4"
    />
    <path
      d="M4.6097 13.4167H11.6627C12.0016 13.4167 12.2763 13.142 12.2763 12.8031C12.2763 12.4641 12.0016 12.1895 11.6627 12.1895H4.6097C4.27078 12.1895 3.99609 12.4641 3.99609 12.8031C3.99609 13.142 4.27078 13.4167 4.6097 13.4167Z"
      fill="#4682B4"
    />
    <path
      d="M12.5136 14.6436H4.6097C4.27078 14.6436 3.99609 14.9182 3.99609 15.2572C3.99609 15.5961 4.27078 15.8708 4.6097 15.8708H12.5136C12.8524 15.8708 13.1272 15.5961 13.1272 15.2572C13.1272 14.9182 12.8524 14.6436 12.5136 14.6436Z"
      fill="#4682B4"
    />
  </svg>
);

export default SVGComponent;
